import { MutationTree } from 'vuex';
import { IntentsState } from '.';
import { ADD_TO_INTENTS_CACHE, CLEAR_INTENTS_CACHE, REMOVE_INTENT_FROM_CACHE, SET_INTENTS, UPDATE_INTENT_IN_CACHE } from './mutationTypes';
import { IntentListItemViewModel } from '@/features/bots/models/intents/intentListItemViewModel';

export const mutations: MutationTree<IntentsState> = {
	[SET_INTENTS](state, intents: IntentListItemViewModel[]) {
		state.intents = intents;
	},

	[CLEAR_INTENTS_CACHE](state) {
		state.intents = [];
	},

	[ADD_TO_INTENTS_CACHE](state, intent: IntentListItemViewModel) {
		state.intents.push(intent);
		state.intents.sort((a, b) => a.title.localeCompare(b.title));
	},

	[UPDATE_INTENT_IN_CACHE](state, updatedIntent: IntentListItemViewModel) {
		const index = state.intents.findIndex(x => x.id === updatedIntent.id);
		if (index !== -1) {
			state.intents[index] = updatedIntent;
			state.intents.sort((a, b) => a.title.localeCompare(b.title));
		}
	},

	[REMOVE_INTENT_FROM_CACHE](state, id: string) {
		const index = state.intents.findIndex(x => x.id === id);
		if (index !== -1) {
			state.intents.splice(index, 1);
		}
	}
};
